import { useState } from 'react';
import { Form, Modal, Input, Button, Space, Card, Radio, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import useCreateOfficalHolidays from 'hooks/query/workSchedule/useCreateOfficalHoildays';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useQueryClient } from 'react-query'
import { addOfficalHolidayReq } from 'models/workSchedule';
interface AddOfficalHolidayProps {
  openAddOfficalHoliday: boolean;
  setOpenAddOfficalHoliday: (openAddOfficalHoliday: boolean) => void;
}


const AddOfficalHoliday = ({ openAddOfficalHoliday, setOpenAddOfficalHoliday }: AddOfficalHolidayProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [holidays, setHolidays] = useState<addOfficalHolidayReq[]>([]);
  const [dateType, setDateType] = useState<string>('');
  const responseCreateOfficalHolidays = useCreateOfficalHolidays();
  const queryClient = useQueryClient()

  const ifListHasFriday = holidays.some((element)=> {
    return element.date === "friday"
  })

  const handleAddHoliday = async () => {
    try {
      const values = await form.validateFields();
      setHolidays(prev => [...prev, values]);
      form.resetFields();
      setDateType('');
    } catch {}
  };
    const handleDeleteHoliday = (indexToDelete: number) => {
        setHolidays(prev => prev.filter((_, index) => index !== indexToDelete));
    };

    const onFinish = async () => {
        if (!holidays.length) return;
        else {
            const formData = new FormData();
            holidays.forEach((holiday, index) => {
            formData.append(`holidays[${index}][date]`, holiday.date);
            formData.append(`holidays[${index}][translations][en]`, holiday.translations.en);
            formData.append(`holidays[${index}][translations][ar]`, holiday.translations.ar);
            });
            responseCreateOfficalHolidays
              .mutateAsync(formData)
              .then(() => {
                queryClient.invalidateQueries({
                queryKey: ['offical-holidays'], // MUST match your useGetOfficalHolidays key
                });
                notification.open({
                  type: 'success',
                  message: t('holidays_created_successfully'),
                });
                handleClose();
              })
              .catch(() => {});

        }
    };

    const handleClose = () => {
    setOpenAddOfficalHoliday(false);
    setHolidays([]);
    form.resetFields();
    setDateType('');

    };

    return (
    <Modal
        title={t('add_offical_holiday')}
        open={openAddOfficalHoliday}
        centered
        destroyOnClose
        onCancel={handleClose}
        closable={{ 'aria-label': 'Custom Close Button' }}
        okButtonProps={{ loading: responseCreateOfficalHolidays.isLoading }}
        onOk={() => {
        holidays.length === 0 ? form.submit() : onFinish();
        }}
    >
        <Form form={form} onFinish={onFinish} labelCol={{ span: 24 }}>
        {
        ifListHasFriday
            ?
            <>
                <Form.Item
                    label={t('holiday_date')}
                    name="date"
                    rules={[{ required: true, message: t('please_enter_date_of_holiday') }]}
                >
                    <Input type="date" />
                </Form.Item>
            </>
            :
            <>
                <Form.Item label={t('select_type')}>
                    <Radio.Group
                        value={dateType}
                        onChange={e => {
                        const value = e.target.value;
                        setDateType(value);
                        if (value === 'day') {
                            form.setFieldsValue({ date: 'friday' });
                        } else {
                            form.setFieldsValue({ date: '' });
                        }
                        }}
                        style={{ marginBottom: 10 }}
                    >
                        <Radio value="day">{t('select_day')}</Radio>
                        <Radio value="date">{t('select_date')}</Radio>
                    </Radio.Group>
                </Form.Item>
                {
                    dateType !== ""
                    ?
                        dateType === 'day' 
                        ? 
                            (
                                <>
                                    <Form.Item name="date" initialValue="friday" noStyle>
                                        <Input type="hidden" />
                                    </Form.Item>
                                    <Input disabled value={t('friday')} />
                                </>
                            ) 
                        : 
                            (
                                <Form.Item
                                    name="date"
                                    rules={[{ required: true, message: t('please_enter_date_of_holiday') }]}
                                >
                                    <Input type="date" />
                                </Form.Item>
                            )
                    :
                        <></>
                }
            </>
        }

        <Form.Item
            label={t('holiday_title_in_english')}
            name={['translations', 'en']}
            rules={[{ required: true, message: t('please_enter_holiday_title_in_english') }]}
            style={{ marginBottom: '10px' }}
        >
            <Input />
        </Form.Item>
        <Form.Item
            label={t('holiday_title_in_arabic')}
            name={['translations', 'ar']}
            rules={[{ required: true, message: t('please_enter_holiday_title_in_arabic') }]}
            style={{ marginBottom: '10px' }}
        >
            <Input />
        </Form.Item>

        <Button type="dashed" block onClick={handleAddHoliday}>
            {t('add')}
        </Button>

        <div style={{maxHeight: "300px", overflowY: 'auto',padding: "0px 10px", marginTop: "10px"}}>
            {holidays.map((holiday, index) => (
            <Card key={index} size="small" style={{marginBottom: "10px"}}>
                <div
                onClick={()=>{handleDeleteHoliday(index)}}
                style={{cursor: "pointer", width: "fit-content", backgroundColor: "#ff0000a1", padding: "5px", borderRadius: "20%", display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "5px"}}>
                    <DeleteOutlined style={{color: "white", fontSize: "20px"}}/>
                </div>
                <div style={{display: "flex", justifyContent: "space-between", gap: "10px", flexWrap: "wrap"}} >
                    <div>
                        <strong>{`${holiday.date == "friday" ? t('holiday_day') : t('holiday_date')} : `}</strong>
                        <div>
                            {holiday.date === 'friday'
                                ? t('friday')
                                : holiday.date
                            }
                        </div>
                    </div>
                    <div>
                        <strong>{`${t('holiday_title_in_english')} : `}</strong>
                        <div>{holiday.translations.en}</div>
                    </div>
                    <div>
                        <strong>{`${t('holiday_title_in_arabic')} : `}</strong>
                        <div>{holiday.translations.ar}</div>
                    </div>
                </div>
            </Card>
            ))}
        </div>
        </Form>
    </Modal>
    );
};

export default AddOfficalHoliday;
